/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Slider from 'react-slick';
import { NoGeozones } from './NoGeozones';
import { GeozoneItem } from './GeozoneItem';
import { NewGeozone } from './NewGeozone';
import {
  activateGeozoneClicked, deleteGeozoneClicked, editGeozoneClicked,
  toggleGeozoneEditor,
} from '../../Modal/GeozonesModal/actions';
import { NextArrow, PrevArrow } from './SliderArrows';

@connect(store => ({
  geozones: store.geozones.currentDeviceGeozones,
  loading: store.geozones.geozonesLoading,
  loadedForDevice: store.geozones.loadedForCurrentDevice,
}),
  dispatch => ({
    createGeozone() {
      return dispatch(toggleGeozoneEditor());
    },
    deleteGeozone(geozone) {
      return dispatch(deleteGeozoneClicked({ ...geozone }));
    },
    editGeozone(geozone) {
      return dispatch(editGeozoneClicked({ geozone }));
    },
    toggleGeozoneStatus(geozone) {
      return dispatch(activateGeozoneClicked({ geozone }));
    },
  }))
export class Geozones extends Component {
  componentWillReceiveProps(nextProps) {
    // code below fix bug of react-slick 0.14.11
    // bug: when you are in the end of slider and delete last geozone slide will not change to previous
    // pull request: -
    // todo: delete code after react-slick was updated
    const geozones = this.props.geozones;
    const nextGeozones = nextProps.geozones;
    if (geozones.length > nextGeozones.length && geozones[geozones.length - 1] !== nextGeozones[nextGeozones.length - 1]) {
      const innerSlider = this.slider && this.slider.innerSlider;
      if (innerSlider && innerSlider.state.currentSlide === nextGeozones.length) {
        innerSlider.changeSlide({
          message: 'index',
          index: nextGeozones.length - 1,
          currentSlide: innerSlider.state.currentSlide,
        });
      }
    }
  }

  render() {
    const { geozones, loading, createGeozone, toggleGeozoneStatus, editGeozone, deleteGeozone, loadedForDevice } = this.props;

    let slider = null;
    if ((!loading && geozones.length > 0) || (loading && loadedForDevice)) {
      slider = (
        <Slider
          ref={(ref) => { this.slider = ref; }}
          dots={false}
          infinite={false}
          speed={500}
          slidesToShow={2}
          slidesToScroll={1}
          draggable={false}
          variableWidth
          nextArrow={<NextArrow />}
          prevArrow={<PrevArrow />}
        >
          {geozones.map(geozone => (
            <div key={geozone.id}>
              <GeozoneItem
                geozone={geozone}
                onActivate={() => { toggleGeozoneStatus(geozone); }}
                onEdit={() => { editGeozone(geozone); }}
                onDelete={() => { deleteGeozone(geozone); }}
              />
            </div>
          )).concat(
            <div key="new">
              <NewGeozone handleCreate={createGeozone} />
            </div>,
          )}
        </Slider>
      );
    }

    return (
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div className="virtual-garage">
          <div className="container clearfix">
            {slider}
            {(!loading && !geozones.length) ? <div><NoGeozones handleAddClick={createGeozone} /></div> : null}
          </div>
        </div>
      </div>
    );
  }
}

Geozones.WrappedComponent.propTypes = {
  createGeozone: PropTypes.func.isRequired,
  toggleGeozoneStatus: PropTypes.func.isRequired,
  editGeozone: PropTypes.func.isRequired,
  deleteGeozone: PropTypes.func.isRequired,
};

Geozones.propTypes = {
  geozones: PropTypes.objectOf(PropTypes.any),
  loading: PropTypes.bool,
  loadedForDevice: PropTypes.bool,
};

Geozones.defaultProps = {
  geozones: undefined,
  loading: undefined,
  loadedForDevice: undefined,
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/Geozones/index.js